export default __webpack_public_path__ + "static/media/ethernet.43194634.svg";